<!-- Center canvas: read-only summary, matches Main Banner's default banner card -->
<div class="cr-mm-card" *ngIf="isPreview">
  <span class="cr-mm-badge">Moments</span>

  <div
    class="cr-mm-dropzone"
    [attr.id]="currentDeviceImage ? block.blockId : null"
    [appInlineMedia]="currentDeviceImage"
    [inlineMediaBlockId]="block.blockId"
    (inlineMediaChange)="onChange($event, currentDeviceImageKey)"
  >
    <a *ngIf="currentDeviceImage; else emptyPreview" [href]="previewHref" target="_blank" rel="noopener">
      <img [src]="currentDeviceImage" [alt]="block.variables?.['MomentsAlt'] || ''" />
    </a>

    <ng-template #emptyPreview>
      <div class="cr-inline-media-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-inline-media-title">Upload image</div>
      <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
    </ng-template>
  </div>
</div>

<!-- Right panel: real edit form (image upload, redirect link + segment, alt text) -->
<div class="cr-mm-edit" *ngIf="!isPreview">
  <div class="cr-mm-field-row">
    <span class="cr-mm-field-label">Desktop Image</span>
    <span
      class="cr-mm-toggle"
      [class.cr-mm-toggle-on]="desktopImageAsUpload"
      role="button"
      tabindex="0"
      [title]="desktopImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleDesktopImageMode()"
      (keydown.enter)="toggleDesktopImageMode()"
      (keydown.space)="toggleDesktopImageMode()"
    ></span>
  </div>
  <div class="cr-mm-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['MomentsImageDesktop'] ?? ''"
      (handleOnChange)="onChange($event, 'MomentsImageDesktop')"
      [placeholder]="imageDesktopPlaceholder"
      variable="MomentsImageDesktop"
      [isImage]="desktopImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-mm-empty-overlay" *ngIf="desktopImageAsUpload && !block.variables?.['MomentsImageDesktop']">
      <div class="cr-mm-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-mm-title">Upload image</div>
      <div class="cr-mm-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-mm-field-row">
    <span class="cr-mm-field-label">Mobile Image</span>
    <span
      class="cr-mm-toggle"
      [class.cr-mm-toggle-on]="mobileImageAsUpload"
      role="button"
      tabindex="0"
      [title]="mobileImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleMobileImageMode()"
      (keydown.enter)="toggleMobileImageMode()"
      (keydown.space)="toggleMobileImageMode()"
    ></span>
  </div>
  <div class="cr-mm-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['MomentsImageMobile'] ?? ''"
      (handleOnChange)="onChange($event, 'MomentsImageMobile')"
      [placeholder]="imageMobilePlaceholder"
      variable="MomentsImageMobile"
      [isImage]="mobileImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-mm-empty-overlay" *ngIf="mobileImageAsUpload && !block.variables?.['MomentsImageMobile']">
      <div class="cr-mm-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-mm-title">Upload image</div>
      <div class="cr-mm-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-mm-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['MomentsHref'] ?? ''"
      (handleOnChange)="onChange($event, 'MomentsHref')"
      [placeholder]="hrefPlaceholder"
      variable="MomentsHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'MomentsHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['MomentsHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-mm-alt-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="alt"
      [blockData]="block.variables?.['MomentsAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'MomentsAlt')"
      [placeholder]="altPlaceholder"
      variable="MomentsAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
